import axios from "axios";
import { toast } from "react-toastify";

export const fileDownloader = (fileURL, token) => {
    let fileName = fileURL.split("/")[fileURL.split("/").length - 3];

    axios.get(fileURL, {
        headers: {
            "Authorization": token ? `Bearer ${token}` : null
        },
        responseType: "blob"
    })
        .then(response => {
            if (response.status === 200) {
                const blob = response.data;
                if (blob.type === "text/plain") {
                    fileName += ".txt";
                }
                let downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = fileName;
                downloadLink.style.display = "none";
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else if (response.status === 204) {
                toast.error("فایل مورد نظر وجود ندارد!");
            }
        })
        .catch(error => {
            toast.error("در دانلود فایل مشکلی رخ داده است!");
        });
}